import moment from 'moment';
import 'moment/locale/ru'; // Import Russian locale
import {ru} from '../lang/ru'
import {en} from '../lang/en'
import {settings} from '../appType/settings.js'
function envVar(value, default_value) {
  if (typeof value === 'string' && value.startsWith('__VUE_APP') && value.endsWith('__')) {
    return default_value
  }

  return value
}

// export const lang = envVar('en', 'ru')
// const envName = envVar('grok', 'stater')
// export const lang = envVar('en', 'en')
// export const envName = envVar('grok', 'grok')

function isTruthy(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const lowerValue = value.toLowerCase();
    return lowerValue === 'true' || lowerValue === '1';
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  return false;
}

export const lang = settings.env.VUE_APP_DEFAULT_LANGUAGE
export const envName = settings.env.VUE_APP_ENV_NAME
export const yandexCaptchaEnabled = isTruthy(settings.env.VUE_APP_YANDEX_CAPTCHA_ENABLED)
export const yandexCaptchaKey = settings.env.VUE_APP_YANDEX_CAPTCHA_KEY

console.log(yandexCaptchaEnabled, yandexCaptchaKey, envName)


const langMap = {
  'en': en,
  'ru': ru,
}

// Set moment locale to Russian
// moment.locale('ru');
moment.locale(lang);


export function getCurrencySymbol(currencyCode) {
  const currencySymbols = {
    'USD': '\u0024', // $
    'EUR': '\u20AC', // €
    'RUB': '\u20BD', // ₽
    'JPY': '\u00A5', // ¥
    'GBP': '\u00A3', // £
    'USDC': '$',
  };
  return currencySymbols[currencyCode] || '\u00A4';  // or ¤
}

export function formatDateTime(isoDatetime) {
  return moment(isoDatetime).format('LLL');
}

export function moneyPrefix(amount) {
  const parsedAmount = parseFloat(amount)

  if (parsedAmount === 0.0) {
    return ""
  } else if (parsedAmount < 0) {
    return "-"
  } else {
    return "+"
  }
}

export function text(textId) {
  if (langMap[lang][textId]) {
    return langMap[lang][textId]
  } else {
    return textId
  }
}



export default {
  install(app, options) {
      app.config.globalProperties.getCurrencySymbol = getCurrencySymbol
      app.config.globalProperties.formatDateTime = formatDateTime
      app.config.globalProperties.moneyPrefix = moneyPrefix
      app.config.globalProperties.text = text
      app.config.globalProperties.envName = envName
      app.config.globalProperties.lang = lang
      app.config.globalProperties.yandexCaptchaEnabled = yandexCaptchaEnabled
      app.config.globalProperties.yandexCaptchaKey = yandexCaptchaKey    }
}
